import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance"

// __________________________ get cms detail ______________________________________
export const getCmsDetailApi = async (data) => {
    const endPoint = "content" + "?" + new URLSearchParams({ ...data, }).toString();
    return await axios.get(endPoint, setJwtToken());
};

// __________________________ update cms ______________________________________
export const updateCmsApi = async (data) => {
    const endPoint = `/content/update`;
    return await axios.post(endPoint, data, setJwtToken());
};
